import { createSelector } from 'reselect';
import _ from 'lodash';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getIngredientMap = state =>
  getStateSlice(state).get('ingredients');

// export const getmarketIngredients = state =>
//   getStateSlice(state).get('marketIngredients');

export const getIngredients = createSelector(
  getIngredientMap,
  ingredientMap => ingredientMap.toList()
);

export const getIngredient = itemCode =>
  createSelector(
    getIngredientMap,
    ingredientMap => ingredientMap.get(itemCode)
  );

export const getIngredientsByFilter = ({
  itemCode = null,
  hasPpi = null,
  owningOrganization = null,
  isExcluded = null,
  userOrganization = null
} = {}) =>
  createSelector(
    getIngredients,
    ingredients => {
      // console.log('owningOrganization', owningOrganization, userOrganization);
      let ingredientsMatching = ingredients;
      if (itemCode) {
        ingredientsMatching = ingredientsMatching.filter(
          ingredient => ingredient.get('itemCode') === itemCode
        );
      }
      if (_.isBoolean(hasPpi)) {
        const hasPpiPredicate = hasPpi
          ? ingredient => !ingredient.get('ppiList').isEmpty()
          : ingredient => ingredient.get('ppiList').isEmpty();
        ingredientsMatching = ingredientsMatching.filter(hasPpiPredicate);
      }
      if (owningOrganization) {
        ingredientsMatching = ingredientsMatching.filter(
          ingredient =>
            ingredient.get('owningOrganization') === owningOrganization
        );
      }
      if (userOrganization) {
        ingredientsMatching = ingredientsMatching.filter(
          ingredient => ingredient.get('userOrganization') === userOrganization
        );
      }
      if (_.isBoolean(isExcluded)) {
        ingredientsMatching = ingredientsMatching.filter(
          ingredient => ingredient.get('isExcluded') === isExcluded
        );
      }
      return ingredientsMatching;
    }
  );

export const getIsFetching = state => getStateSlice(state).get('isFetching');

export const getIsFetched = state => getStateSlice(state).get('isFetched');

export const getIsGlobalFetching = state =>
  getStateSlice(state).get('isGlobalFetching');

export const getIsGlobalFetched = state =>
  getStateSlice(state).get('isGlobalFetched');

export const getIsExcludedFetching = state =>
  getStateSlice(state).get('isExcludedFetching');

export const getIsExcludedFetched = state =>
  getStateSlice(state).get('isExcludedFetched');

export const getIsExcluding = state => getStateSlice(state).get('isExcluding');

export const getExcludeError = state =>
  getStateSlice(state).get('excludeError');

export const getIsIncluding = state => getStateSlice(state).get('isIncluding');

export const getIncludeError = state =>
  getStateSlice(state).get('includeError');
